module.exports = __webpack_public_path__ + "static/media/aaron.6d98ddb3.png";